import { GsFormField, GsFormFieldSelect, GsFormSchema } from 'libs/shared/src/components';
import { ContentType } from 'libs/shared/src/models';
import { generateSwiperSchemaFields } from '../../basics';
import { ZOOM_SCHEMA_FIELDS } from '../../basics/zoom.schema';
import {
  ARTICLE_INFO_BASE_FORM_SCHEMA,
  ARTICLE_INFO_PURCHASE_BUTTON_SCHEMA,
  ARTICLE_INFO_QUALITY_EXPLANATION_SCHEMA,
  ARTICLE_INFO_REFERENCES_SCHEMA,
  ARTICLE_INFO_SLAVE_DISPLAY_SCHEMA,
  ARTICLE_INFO_THUMBNAILS_POSITION_SCHEMA,
  ARTICLE_INFO_UNAVAILABLE_VARIANTS_SCHEMA
} from './base/article-info-base.schema';

const swiperFields = generateSwiperSchemaFields(false, []);

// Override items-per-row constraints for article-info:
// Desktop/Tablet: min 2, max 8 | Mobile: min 0, max 4
const articleInfoSwiperFields = swiperFields.map((field) => {
  if (field.formControlName === 'itemsRowDesktop') return { ...field, min: 2, max: 8, default: 4 };
  if (field.formControlName === 'itemsRowTablet') return { ...field, min: 2, max: 8, default: 2 };
  if (field.formControlName === 'itemsRowMobile') return { ...field, min: 0, max: 4, default: 1 };
  return field;
}) as GsFormField<never>[];

export const ARTICLE_INFO_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ARTICLE_INFO_BASE_FORM_SCHEMA,
    ...ARTICLE_INFO_PURCHASE_BUTTON_SCHEMA, // Both buy buttons, only add-to-cart or only add-to-inquiry-list
    ...ARTICLE_INFO_THUMBNAILS_POSITION_SCHEMA,
    ...articleInfoSwiperFields,
    ...ZOOM_SCHEMA_FIELDS,
    ...ARTICLE_INFO_REFERENCES_SCHEMA, // References section settings / Setting just for ArticleInfo (Product) for now / Prepared for ArticleInfoBaseStruct
    ...ARTICLE_INFO_SLAVE_DISPLAY_SCHEMA, // Master/Slave variant groups: render as buttons or dropdown
    ...ARTICLE_INFO_UNAVAILABLE_VARIANTS_SCHEMA, // Unavailable variants in dropdowns: normal, hide or grayout
    ...ARTICLE_INFO_QUALITY_EXPLANATION_SCHEMA, // Link to the quality/variant explanation page
    {
      formControlName: 'segmentBars',
      label: 'components.articleInfo.schema.infoTabs',
      type: 'object-list',
      default: [],
      maxObjectsAmount: 6,
      objectSchema: {
        fields: [
          {
            formControlName: 'name',
            label: 'components.articleInfo.schema.name',
            type: 'text',
            labelPosition: 'left',
            default: 'New Tab'
          },
          {
            formControlName: 'contentType',
            label: 'components.articleInfo.schema.contentType',
            type: 'select',
            default: 'details',
            labelPosition: 'left',
            options: [
              { text: 'components.articleInfo.schema.options.details', value: 'details' },
              { text: 'components.articleInfo.schema.options.description', value: 'description' },
              { text: 'components.articleInfo.schema.options.texts', value: 'texts' },
              { text: 'components.articleInfo.schema.options.detailsWithPictograms', value: 'detailsWithPictograms' },
              { text: 'components.articleInfo.schema.options.purchaseArguments', value: 'purchaseArguments' },
              { text: 'components.articleInfo.schema.options.articleProperties', value: 'articleProperties' },
              { text: 'components.articleInfo.schema.options.pictoGrid', value: 'pictoGrid' },
              { text: 'components.articleInfo.schema.options.faq', value: 'faq' },
              { text: 'components.articleInfo.schema.options.ratings', value: 'ratings' }
            ]
          } as GsFormFieldSelect<ContentType>,
          {
            formControlName: 'sortIndex',
            label: 'components.articleInfo.schema.sortIndex',
            type: 'number',
            labelPosition: 'left',
            min: 0,
            default: 0
          }
        ]
      }
    }
  ]
};
